//const environment = process.env.REACT_APP_ENV;

export const getDocUrl = (externalUrl) => {
    // switch (environment) {
    //     case "prod":
    //         return `https://curesickle.org/sites/default/files/${externalUrl}`;
    //     case "test":
    //         return `https://curesickle.org/sites/default/files/${externalUrl}`;
    //     default:
    //         return `./${externalUrl}`;
    // }

    return `https://curesickle.org/sites/default/files/${externalUrl}`;
};
